import { render, staticRenderFns } from "./pic-edit.vue?vue&type=template&id=d92b922a&scoped=true&"
import script from "./pic-edit.vue?vue&type=script&lang=js&"
export * from "./pic-edit.vue?vue&type=script&lang=js&"
import style0 from "./pic-edit.vue?vue&type=style&index=0&id=d92b922a&lang=less&scoped=true&"
import style1 from "./pic-edit.vue?vue&type=style&index=1&id=d92b922a&lang=less&scoped=true&"
import style2 from "@/assets/less/i-switch.less?vue&type=style&index=2&id=d92b922a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92b922a",
  null
  
)

component.options.__file = "pic-edit.vue"
export default component.exports